import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Mail, MessageSquare, Send, Phone } from 'lucide-react';
import { toast } from 'sonner';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    const subject = encodeURIComponent(formData.subject || 'Germanatic Kontaktanfrage');
    const body = encodeURIComponent(
      `Name: ${formData.name}\nE-Mail: ${formData.email}\n\n${formData.message}`
    );
    // Opens the user's local email client — no data passes through Germanatic servers.
    window.location.href = `mailto:teomantalay21@gmail.com?subject=${subject}&body=${body}`;
    toast.success('Opening your email app... / E-Mail-App wird geöffnet...');
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-babyblue-50 via-babyblue-100/50 to-white flex flex-col">
      <Navbar />

      <main className="flex-1 py-12 px-6">
        <div className="container mx-auto max-w-4xl">
          <div className="text-center mb-12">
            <h1 className="font-heading text-4xl font-bold text-babyblue-800 mb-4">Contact Us</h1>
            <p className="text-lg text-babyblue-600">
              Have questions or feedback? We'd love to hear from you!
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
            <div className="card p-6">
              <Mail className="w-10 h-10 text-primary mb-4" />
              <h3 className="font-heading text-lg font-semibold text-babyblue-800 mb-2">Email Us</h3>
              <p className="text-babyblue-500 text-sm mb-3">
                For general inquiries
              </p>
              <a href="mailto:teomantalay21@gmail.com" className="text-primary hover:underline text-sm">
                teomantalay21@gmail.com
              </a>
            </div>

            <div className="card p-6">
              <Phone className="w-10 h-10 text-primary mb-4" />
              <h3 className="font-heading text-lg font-semibold text-babyblue-800 mb-2">Call Us</h3>
              <p className="text-babyblue-500 text-sm mb-3">
                Mon-Fri, 9am-5pm CET
              </p>
              <a href="tel:+4915902221377" className="text-primary hover:underline text-sm">
                +491590 2221377
              </a>
            </div>

            <div className="card p-6">
              <MessageSquare className="w-10 h-10 text-primary mb-4" />
              <h3 className="font-heading text-lg font-semibold text-babyblue-800 mb-2">Feedback</h3>
              <p className="text-babyblue-500 text-sm">
                Help us improve our platform
              </p>
            </div>
          </div>

          <div className="card p-8">
            <h2 className="font-heading text-2xl font-semibold text-babyblue-800 mb-2">Send us a Message / Nachricht senden</h2>
            <p className="text-babyblue-500 text-sm mb-6">
              Clicking "Send Message" will open your email app — your data never passes through Germanatic servers.
              <br />
              <span className="italic">Beim Klick auf „Send Message" öffnet sich Ihre E-Mail-App — Ihre Daten werden nicht an Germanatic übermittelt.</span>
            </p>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-babyblue-600 mb-2">Name</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 bg-white border-2 border-primary/30 rounded-lg focus:border-primary focus:outline-none transition-colors text-babyblue-800 placeholder-gray-500"
                    placeholder="Your name"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-babyblue-600 mb-2">Email</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 bg-white border-2 border-primary/30 rounded-lg focus:border-primary focus:outline-none transition-colors text-babyblue-800 placeholder-gray-500"
                    placeholder="your@email.com"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-babyblue-600 mb-2">Subject</label>
                <input
                  type="text"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 bg-white border-2 border-primary/30 rounded-lg focus:border-primary focus:outline-none transition-colors text-babyblue-800 placeholder-gray-500"
                  placeholder="How can we help?"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-babyblue-600 mb-2">Message</label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="6"
                  className="w-full px-4 py-3 bg-white border-2 border-primary/30 rounded-lg focus:border-primary focus:outline-none transition-colors text-babyblue-800 placeholder-gray-500 resize-none"
                  placeholder="Tell us more about your inquiry..."
                />
              </div>

              <button
                type="submit"
                className="btn-primary flex items-center gap-2"
              >
                <Send className="w-4 h-4" />
                Send Message
              </button>
            </form>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default ContactPage;
